export enum KpiACTypes {
  'LOAD_REQUEST' = '@kpiAC/LOAD_REQUEST',
  'LOAD_SUCCESS' = '@kpiAC/LOAD_SUCCESS',
  'LOAD_FAILURE' = '@kpiAC/LOAD_FAILURE',
}

export interface IPoint {
  time: string;
  value: number;
}

export interface IKpi {
  card: string;
  data: IPoint[];
  protocolos: number[];
  qtd: number;
  total: number;
}

export interface KpiACState {
  readonly data: IKpi[];
  readonly error: boolean;
  readonly loading: boolean;
}
